/** biome-ignore-all lint/suspicious/noArrayIndexKey: no index in key */
import {shallowEqual, useSelector} from 'react-redux';
import {selectPost} from '~/ViewInvitation/reducers/posts';
import {Reply} from '~/ViewInvitation/routes/Guests/Reply';
import {ViewMoreRepliesButton} from '~/ViewInvitation/routes/Guests/ViewMoreRepliesButton';

export const Replies = (props) => {
  const {parentId, handleCommentOpen, handleSetEditing, isEditingComment, postBeingEdited} = props;

  if (!parentId) return null;
  const parentPost = useSelector(selectPost(parentId), shallowEqual);

  if (parentPost.replyIds.length === 0) return null;

  const {replyIds} = parentPost;

  return (
    <>
      <Reply
        handleCommentOpen={handleCommentOpen}
        handleSetEditing={handleSetEditing}
        isEditingComment={isEditingComment}
        postId={parentPost.replyIds[0]}
        isEditingThisComment={postBeingEdited === parentPost.replyIds[0]}
      />
      {replyIds.length > 1 && (
        <>
          <ViewMoreRepliesButton
            remainingReplyCount={replyIds.length - 1}
            parentPostId={parentId}
          />
          <div id={`hiddenposts-${parentId}`} className="bonus-replies hidden">
            {replyIds.slice(1).map((reply, i) => (
              <Reply
                key={`guest-reply__${i}`}
                parentPostId={parentId}
                handleCommentOpen={handleCommentOpen}
                handleSetEditing={handleSetEditing}
                postId={reply}
                isEditingComment={isEditingComment}
                isEditingThisComment={postBeingEdited === reply}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
};
